import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import Tag from 'components/UI/Tag';
import LazyImage from 'components/UI/LazyImage';
import { useTrans } from 'utils/localisation';

import * as styles from './TagsFiltersModal.module.scss';

export default function TagsFiltersModal({
  filters,
  setFilters,
  className,
  flags,
  setShowTags,
  showCount = 5,
}) {
  const t = useTrans(['filters', 'common']);
  const [showMore, setShowMore] = useState(false);
  const preparedFilters = Object.entries(filters).flatMap(([filterKey, filterValues]) =>
    filterValues.map(item => ({ ...item, filterKey })),
  );
  const activeFilters = preparedFilters?.length;

  useEffect(() => {
    if (!activeFilters) {
      setShowTags(false);
    }
  }, [activeFilters]);

  const setItem = (item, option) => {
    const selected = filters[option];
    const result = selected.some(({ value }) => value === item.value)
      ? selected.filter(({ value }) => value !== item.value)
      : [...selected, item];

    setFilters(prev => ({
      ...prev,
      [option]: result,
    }));
  };

  const handleShowMore = () => {
    setShowMore(!showMore);
  };

  const renderTags = () =>
    preparedFilters.map(({ value, label, filterKey }, i) => (
      <Tag
        key={label}
        className={cn(styles.tag, i >= showCount && !showMore && styles.hidden)}
        theme="ovalWithButton"
        onClick={() => setItem({ value, label }, filterKey)}
      >
        <div className={styles.tagContent}>
          {flags[label] && <LazyImage src={flags[label]} alt={label} className={styles.flag} />}
          {label}
        </div>
      </Tag>
    ));

  return (
    <div className={className}>
      <div className={styles.wrapper}>
        <p className={styles.title}>{`${t('filteredBy')} (${activeFilters})`}</p>
        <div className={styles.tagsWrapper}>{renderTags()}</div>
        {activeFilters > showCount && (
          <div>
            <button
              onClick={handleShowMore}
              className={cn(styles.showMore, showMore && styles.active)}
            >
              {!showMore ? t('showMore') : t('showLess')}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
